var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.mode === "login"
        ? _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "title" }, [_vm._v("Log In")]),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c("v-text-field", {
                    attrs: { label: "Email", id: "login-email" },
                    model: {
                      value: _vm.email,
                      callback: function($$v) {
                        _vm.email = $$v
                      },
                      expression: "email"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      type: "password",
                      label: "Password",
                      id: "login-password"
                    },
                    model: {
                      value: _vm.password,
                      callback: function($$v) {
                        _vm.password = $$v
                      },
                      expression: "password"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-layout",
                    { attrs: { column: "" } },
                    [
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "mx-0 px-0",
                              attrs: { color: "primary" },
                              on: { click: _vm.signIn }
                            },
                            [_vm._v("Log In")]
                          ),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "accent--text",
                              attrs: { flat: "" },
                              on: {
                                click: function($event) {
                                  return _vm.$store.dispatch(
                                    "applications/hideSessionModal"
                                  )
                                }
                              }
                            },
                            [_vm._v("Cancel")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-menu",
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mx-0 px-0 mt-2",
                                  attrs: {
                                    slot: "activator",
                                    flat: "",
                                    small: ""
                                  },
                                  slot: "activator"
                                },
                                [
                                  _vm._v(
                                    "\n              Advanced Login\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list",
                                [
                                  _c(
                                    "v-list-tile",
                                    { on: { click: _vm.googleSignIn } },
                                    [
                                      _c(
                                        "v-list-tile-content",
                                        { staticClass: "align-center" },
                                        [
                                          _c("img", {
                                            attrs: {
                                              height: "30",
                                              src: "/static/icon-40px.png"
                                            }
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mx-0 px-0 mt-2",
                              attrs: { flat: "", small: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.mode = "password"
                                }
                              }
                            },
                            [_vm._v("Forgot password?")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "title" }, [
                _vm._v("Reset your password")
              ]),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c("v-text-field", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|email",
                        expression: "'required|email'"
                      }
                    ],
                    attrs: {
                      label: "Enter your email address",
                      "error-messages": _vm.errors.first("email"),
                      "data-vv-as": "Email address",
                      "data-vv-name": "email"
                    },
                    model: {
                      value: _vm.resetEmail,
                      callback: function($$v) {
                        _vm.resetEmail = $$v
                      },
                      expression: "resetEmail"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.sendEmail()
                        }
                      }
                    },
                    [_vm._v("Send reset email")]
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          _vm.mode = "login"
                        }
                      }
                    },
                    [_vm._v("Back to Login")]
                  )
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8dac4566", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8dac4566","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoginForm.vue
// module id = null
// module chunks = 